export default "__VITE_ASSET__DfCShM3x__"